module.exports = __webpack_public_path__ + "static/media/what-do-we-mean-by-cuts.b2f23289.svg";